import { render, staticRenderFns } from "./Sterling.vue?vue&type=template&id=e32684e2&scoped=true"
import script from "./Sterling.vue?vue&type=script&lang=js"
export * from "./Sterling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32684e2",
  null
  
)

export default component.exports